<template>
    <nav class="layoutFooter layoutRow layoutFooter">
      <div id="footerContent"></div>
    </nav>
</template>

<script setup>
import { watch } from 'vue';
import dataManager from '@/services/dataManager';
import globals from '@/services/globals';

// Preserve the existing model-ready read of paused jobs and retained drafts.
// Recovery state belongs to dataManager; the footer no longer presents it.
watch(globals.dataModelReady, ready => {
  if (ready && globals.getAlreadyAuthenticated() === 'YES') {
    dataManager.refreshPausedSyncJobs().fail(() => {});
  }
}, { immediate: true });
</script>
